import { DeleteOutlined, SaveOutlined, DownloadOutlined } from '@ant-design/icons';
import { Button, Col, DatePicker, Form, Input, Row, Select, Space, Tabs, Tag } from "antd";
import dayjs from 'dayjs';
import { useEffect, useState } from "react";
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from "react-toastify";
import { ContentHeader } from '../../../components';
import ModalTextForm from '../../../components/modal/ModalTextForm';
import { Links } from '../../../helpers/Links';
import { validateMessages } from '../../../helpers/common';
import TableThuLaoNDD from '../../../modules/salary/TableThuLaoNDD';
import { duyetThuLaoNguoiDaiDien, getByIdThuLaoNguoiDaiDien, getDsNguoiDaiDien, saveThuLaoNguoiDaiDien, trinhThuLaoNguoiDaiDien, xoaThuLaoNguoiDaiDien, xuatExcelThuLaoNDD } from '../../../services/thulaonguoidaidien';
import { hideLoadingScreen, showLoadingScreen } from '../../../store/reducers/loading';

var optionsThuLao = [{
    value: 1,
    label: "Theo năm"
},
{
    value: 2,
    label: "Theo quý"
}];

const ThuLaoNDD = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [form] = Form.useForm();

    const [showModalDelete, setShowModalDelete] = useState<boolean>(false);
    const [showModalTrinh, setShowModalTrinh] = useState<boolean>(false);
    const [showModalDuyet, setShowModalDuyet] = useState<boolean>(false);

    const [dataTable, setDataTable] = useState<Array<any>>([]);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const id = Form.useWatch('id', form);
    const loai = Form.useWatch('loai', form);
    const trangThai = Form.useWatch('trangThai', form);

    const eventTrinh = async () => {
        try {
            setShowModalTrinh(false);
            dispatch(showLoadingScreen());
            await trinhThuLaoNguoiDaiDien(id);
            navigate(Links.ThuLaoNguoiDaiDien.DanhSach);
            toast.success("Trình thù lao người đại điện thành công");
        }
        catch (e: any) {
            toast.error(e);
        }
        dispatch(hideLoadingScreen());
    }

    const eventDuyet = async () => {
        try {
            setShowModalDuyet(false);
            dispatch(showLoadingScreen());
            await duyetThuLaoNguoiDaiDien(id);
            navigate(Links.ThuLaoNguoiDaiDien.DanhSach);
            toast.success("Duyệt thù lao người đại điện thành công");
        }
        catch (e: any) {
            toast.error(e);
        }
        dispatch(hideLoadingScreen());
    }

    const eventSave = async () => {
        if (isLoading) return;
        form.validateFields().then(async (values) => {
            dispatch(showLoadingScreen());
            setIsLoading(true);
            try {
                var data: any = {
                    id: values.id,
                    ten: values.ten,
                    thangNhan: values.thangNhan,
                    loai: values.loai,
                    chiTiet: dataTable,
                };

                if (data.loai === 1) {
                    data.nam = values.nam.year();
                } else {
                    data.nam = values.quy.year();
                    data.quy = Math.floor(values.quy.month() / 3) + 1;
                }
                
                var response = await saveThuLaoNguoiDaiDien(data);
                loadData(response);
                if (!data.id) {
                    navigate(Links.ThuLaoNguoiDaiDien.ChiTiet + "?id=" + response.id);
                }

                toast.success("Lưu thù lao người đại diện thành công");
            } catch (error: any) {
                toast.error(error);
            }
            dispatch(hideLoadingScreen());
            setIsLoading(false);
        }).catch((e) => {
            toast.error("Có lỗi xảy ra. Vui lòng thử lại sau.");
        });
    }

    const eventDelete = async () => {
        try {
            setShowModalDelete(false);
            dispatch(showLoadingScreen());
            await xoaThuLaoNguoiDaiDien(id);
            navigate(Links.ThuLaoNguoiDaiDien.DanhSach);
            toast.success("Xóa thù lao người đại điện thành công");
        }
        catch (e: any) {
            toast.error(e);
        }
        dispatch(hideLoadingScreen());
    }

    const getById = async (idLQT: any) => {
        dispatch(showLoadingScreen());
        setIsLoading(true);
        try {
            var response = await getByIdThuLaoNguoiDaiDien(idLQT);
            loadData(response);
        }
        catch (e: any) {
            toast.error(e)
        }
        setIsLoading(false);
        dispatch(hideLoadingScreen());
    }

    const getDsNDD = async () => {
        dispatch(showLoadingScreen());
        setIsLoading(true);
        try {
            var loai = form.getFieldsValue(['loai'])?.loai;
            var nam = form.getFieldsValue(['loai'])?.loai === 1 ? form.getFieldsValue(['nam'])?.nam?.$y : form.getFieldsValue(['quy'])?.quy?.$y            
            var quy = form.getFieldsValue(['loai']).loai === 1 ? 0 : Math.floor(form.getFieldsValue(['quy'])?.quy?.$M / 3 + 1);           
            var response = await getDsNguoiDaiDien(quy, nam, loai);
            loadData(response);
        }
        catch (e: any) {
            toast.error(e)
        }
        setIsLoading(false);
        dispatch(hideLoadingScreen());
    }

    const loadData = (response: any) => {
        var dform: any = {
            id: response.id,
            ten: response.ten,
            thangNhan: response.id > 0 ? dayjs(response.thangNhan) : dayjs(new Date()),
            loai: response.loai || 2,
            nam: response.nam > 0 ? dayjs(new Date(response.nam, 0, 1)) : dayjs(new Date()),
            quy: response.loai == 2 ? dayjs(new Date(response.nam, (response.quy -1 ) * 3, 1)) : dayjs(new Date()),
            trangThai: response.trangThai
        };

        form.setFieldsValue(dform);
        setDataTable(response.chiTiet);
    }
    const handleExport = async () => {
        dispatch(showLoadingScreen());
        try {
            var response = await xuatExcelThuLaoNDD(id);
            let link = document.createElement('a');
            link.download = `ThuLaoNDD.xlsx`;
            let blob = new Blob([response.data], { type: response.data.type });
            link.href = URL.createObjectURL(blob);
            link.click();
            URL.revokeObjectURL(link.href);
        } catch (ex) {
            toast.error("Xuất báo không thành công. Vui lòng thử lại");
        }

        dispatch(hideLoadingScreen());
    }
    useEffect(() => {
        const params = new URLSearchParams(window.location.search)
        let idLQT = +(params.get('id') || '');
        if (idLQT > 0) {
            getById(idLQT);
        }
        else {
            var dform: any = {
                id: 0,
                ten: "",
                thangNhan: dayjs(new Date()),
                loai: 2,
                nam: dayjs(new Date()),
                quy: dayjs(new Date()),
                trangThai: 0
            };

            form.setFieldsValue(dform);
            getDsNDD();
        }
    }, [])

    return <section>
        {showModalDelete && <ModalTextForm show
            title="Xoá Thù lao người đại diện"
            handleClose={() => setShowModalDelete(false)}
            handleSave={eventDelete}>
            Xác nhận xóa Thù lao người đại diện
        </ModalTextForm>}
        {showModalTrinh && <ModalTextForm show
            title="Trình Thù lao người đại diện"
            handleClose={() => setShowModalTrinh(false)}
            handleSave={eventTrinh}>
            Xác nhận trình Thù lao người đại diện
        </ModalTextForm>}
        {showModalDuyet && <ModalTextForm show
            title="Duyệt Thù lao người đại diện"
            handleClose={() => setShowModalDuyet(false)}
            handleSave={eventDuyet}>
            Xác nhận duyệt Thù lao người đại diện
        </ModalTextForm>}
        <ContentHeader title="Thanh toán Thù lao người đại diện" />
        <Tabs
            tabBarExtraContent={
                <Space>
                    {
                        id > 0 && 
                        <Button
                            loading={isLoading}
                            className="hrm-btn hrm-btn-success"
                            icon={<DownloadOutlined rev="" />}
                            onClick={handleExport}
                        >Xuất excel
                        </Button>
                    }
                    {
                        id > 0 && trangThai == 0 &&
                        <Button
                            type="primary" danger
                            icon=<DeleteOutlined rev="" />
                            onClick={() => { setShowModalDelete(true) }}
                        >
                            Xóa
                        </Button>
                    }
                    {
                        id > 0 && trangThai == 0 &&
                        <Button
                            type="primary" 
                            icon=<SaveOutlined rev="" />
                            onClick={() => { setShowModalTrinh(true) }}
                        >
                            Trình phê duyệt
                        </Button>
                    }
                    {
                        trangThai == 2 &&
                        <Button
                            type="primary"
                                icon=<SaveOutlined rev="" />
                                onClick={() => { setShowModalDuyet(true) }}
                        >
                            Duyệt
                        </Button>
                    }
                    {
                        (trangThai == 0 || trangThai == undefined) &&
                        <Button
                            type="primary"
                            icon={<SaveOutlined rev="" />}
                            onClick={eventSave}
                        >
                            Lưu
                        </Button>
                    }
                    
                </Space>}
            defaultActiveKey="1" items={[
                {
                    key: "1",
                    label: "Thù lao người đại diện",
                    children:
                        <Row>
                            <Col span="24" className="card card-body">
                                <Form
                                    layout="vertical"
                                    validateMessages={validateMessages}
                                    form={form}
                                >
                                    <Row gutter={12}>
                                        <Col span="12" >
                                            <Form.Item hidden name="id"><Input /></Form.Item>
                                            <Form.Item hidden name="trangThai"><Input /></Form.Item>
                                            <Form.Item rules={[
                                                {
                                                    required: true
                                                }
                                            ]} label="Tên thanh toán" name="ten">
                                                <Input readOnly={trangThai > 0} />
                                            </Form.Item>
                                        </Col>
                                        <Col span="6">
                                            <Form.Item rules={[
                                                {
                                                    required: true
                                                }
                                            ]} label="Loại thanh toán" name="loai">
                                                <Select notFoundContent="Không có dữ liệu" disabled={trangThai > 0}
                                                    onChange={getDsNDD}
                                                    options={optionsThuLao}
                                                    loading={isLoading}
                                                    placeholder="Loại quyết toán" />
                                            </Form.Item>
                                        </Col>
                                        <Col span="6">
                                            <Form.Item rules={[
                                                {
                                                    required: loai === 1 ? true : false
                                                },
                                            ]} label="Kỳ thanh toán" name="nam" hidden={loai != 1}>
                                                {
                                                    loai === 1 &&
                                                    <DatePicker
                                                        onChange={getDsNDD}
                                                        changeOnBlur={true}
                                                        disabled={trangThai > 0}
                                                        style={{ width: "100%" }}
                                                        format="YYYY"
                                                        placeholder="Chọn năm thanh toán"                                                        
                                                        picker="year" />
                                                }
                                            </Form.Item>
                                            <Form.Item rules={[
                                                {
                                                    required: loai === 2 ? true : false
                                                },
                                            ]} label="Kỳ thanh toán" name="quy" hidden={loai != 2}>
                                                <DatePicker
                                                    onChange={getDsNDD}
                                                    changeOnBlur={true}
                                                    disabled={trangThai > 0}
                                                    style={{ width: "100%" }}
                                                    placeholder="Chọn quý thanh toán"                                                    
                                                    picker="quarter" />
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                    <Row gutter={12}>
                                        <Col span="6">
                                            <Form.Item rules={[
                                                {
                                                    required: true
                                                },
                                            ]} label="Tháng chi trả" name="thangNhan" >
                                                <DatePicker
                                                    changeOnBlur={true}
                                                    disabled={trangThai > 0}
                                                    picker="month"
                                                    style={{ width: "100%" }}
                                                    placeholder="Chọn tháng"
                                                    format={["MM/YYYY", "MMYYYY"]}
                                                    allowClear={false}
                                                />
                                            </Form.Item>
                                        </Col>
                                        {
                                            !!id &&
                                            <Col span="6">
                                                <Form.Item label="Trạng thái" key="trangThai">
                                                        {
                                                            trangThai == 0 &&
                                                            <Tag color="processing">Khởi tạo</Tag>
                                                        }
                                                        {
                                                            trangThai == 1 &&
                                                            <Tag color="success">Đã duyệt</Tag>
                                                        }
                                                        {
                                                            trangThai == 2 &&
                                                            <Tag color="warning">Trình duyệt</Tag>
                                                        }
                                                </Form.Item>
                                            </Col>
                                        }
                                    </Row>
                                </Form>
                            </Col>
                        </Row>
                }]} />        
        <TableThuLaoNDD isEdit={true} isLoading={isLoading} dataTable={dataTable} loaiDanhGia={(form.getFieldsValue(['loai'])?.loai === 1)} trangThai={trangThai} onChange={(d) => {
            setDataTable([...d]);
        }} />
    </section >
}

export default ThuLaoNDD;